import React from "react";
import { Formik } from "formik";
import { TextField, Typography } from "@material-ui/core";

import { appRoutes } from "routes";
import { useRouter, useUsers } from "hooks";
import Placeholder from "components/Placeholder";
import AccountLayout from "layouts/AccountLayout";
import UserPresenter from "presenters/UserPresenter";
import { validationSchema } from "forms/ChangeEmailForm";
import MetaTags from "components/MetaTags";

import { CancelButton, InputPlaceholder, Title, SaveButton } from "../components";

import useStyles from "./useStyles";

const ChangeEmail = () => {
  const classes = useStyles();
  const { push } = useRouter();
  const { currentUser, updateUser } = useUsers();

  const handleSubmit = (values, formikBag) => {
    const params = {
      data: {
        attributes: { email: values.email },
        type: "users",
      },
    };
    return updateUser(params).then(
      () => {
        push(appRoutes.myAccountPath());
      },
      (error) => {
        let errorMsg = error.response.data.errors[0].detail;

        if (errorMsg.indexOf("has already been taken") > -1) {
          errorMsg = "That email address is already in use";
        }
        if (errorMsg.includes("already exists") > -1) {
          errorMsg = "That email address is already in use";
        }

        formikBag.setFieldError("email", errorMsg);
      },
    );
  };

  return (
    <>
      <AccountLayout title="Funny eCards - Send Custom Greeting Cards Online w/ JibJab! - My Account - Change Email">
        <Title title="Edit Email Address" subtitle="Current Email Address:">
          <Typography className={classes.longText}>
            {currentUser ? (
              <b>{UserPresenter.email(currentUser)}</b>
            ) : (
              <Placeholder variant="text" width={120} className={classes.emailPlaceholder} />
            )}
          </Typography>
        </Title>

        {currentUser ? (
          <Formik
            initialValues={{ email: UserPresenter.email(currentUser) }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit} className={classes.form}>
                <TextField
                  margin="normal"
                  placeholder="Email"
                  id="email"
                  helperText={formik.touched.email && formik.errors.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  {...formik.getFieldProps("email")}
                />

                <SaveButton>Update Email</SaveButton>
              </form>
            )}
          </Formik>
        ) : (
          <InputPlaceholder />
        )}

        <CancelButton />
      </AccountLayout>
      <MetaTags>
        <meta
          name="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous & more!"
        />
      </MetaTags>
    </>
  );
};

export default ChangeEmail;
